import { useApolloClient, useMutation } from '@apollo/client';
import { rescueSendSmsMutation } from '../lib/rescueQueries';
import { trackDeviceSmsSent } from '../analytics';
import { useToast } from '../components/Toast/ToastContext';

/**
 * Sends a Pending or Foster row's text through `rescueSendSms`. A refused send refreshes the paged rows: the
 * usual reason is a number that just replied STOP, and the row's Send SMS should show disabled without a
 * reload.
 */
export default function useSendRescueSms() {
  const client = useApolloClient();
  const { showToast } = useToast();
  const [send] = useMutation(rescueSendSmsMutation);

  return async function sendRescueSms(phoneNumber: string, message: string) {
    try {
      await send({ variables: { input: { phoneNumber, message } } });
      trackDeviceSmsSent();
      showToast('SMS sent successfully');
    } catch (err) {
      showToast(`Failed to send SMS: ${err instanceof Error ? err.message : 'Unknown error'}`);
      // A refetch that fails surfaces through the rows' own queries, which show their error state.
      await client.refetchQueries({ include: ['rescueDevicePage'] }).catch(() => undefined);
    }
  };
}
